import { PbxHttpClient } from "@/services/httpclient";

const state = {
  allCLients: [],
  allExternalCLients: [],
};

const getters = {
  GET_ALL_CLIENTS(state) {
    return state.allCLients;
  },
};

const mutations = {
  SET_ALL_CLIENTS(state, payload) {
    state.allCLients = payload;
  },

  SET_ALL_EXTERNAL_CLIENTS(state, payload) {
    state.allExternalCLients = payload;
  },

  PUSH_CLIENT: (state, payload) => {
    const value = state.allCLients.find((element) => {
      return element.id === payload.id;
    });
    if (value === undefined) {
      state.allCLients.push(payload);
    }
  },

  PUSH_EXTERNAL_CLIENT: (state, payload) => {
    // const value = state.allExternalCLients.find((element) => {
    //   return element.id === payload.id;
    // });
    // if (value === undefined) {
    // console.log("state", state.allExternalCLients);
    state.allExternalCLients.push(payload);
    // }
  },

  UPDATE_USER: (state, payload) => {
    // console.log("informacion del usuario", payload);
    const indexupdate = state.allCLients
      .map((element) => {
        return element.id;
      })
      .indexOf(payload.id);
    if (indexupdate > -1) {
      state.allCLients.splice(indexupdate, 1, payload);
    }
  },

  UPDATE_EXTERNAL_USER: (state, payload) => {
    // console.log("informacion del usuario", payload);
    const indexupdate = state.allExternalCLients
      .map((element) => {
        return element.id;
      })
      .indexOf(payload.id);
    if (indexupdate > -1) {
      state.allExternalCLients.splice(indexupdate, 1, payload);
    }
  },

  DELETE_USER: (state, payload) => {
    const indexdelete = state.allCLients
      .map((element) => {
        return element.id;
      })
      .indexOf(payload);
    if (indexdelete > -1) {
      state.allCLients.splice(indexdelete, 1);
    }
  },

  DELETE_EXTERNAL_USER: (state, payload) => {
    const indexdelete = state.allExternalCLients
      .map((element) => {
        return element.id;
      })
      .indexOf(payload);
    if (indexdelete > -1) {
      state.allExternalCLients.splice(indexdelete, 1);
    }
  },
};

const actions = {
  async REGISTER_CLIENTS({ commit }, payload) {
    try {
      const response = await PbxHttpClient.post("/clients/register", payload);
      commit("PUSH_CLIENT", response.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async REGISTER_EXTERNAL_CLIENTS({ commit }, payload) {
    try {
      // console.log("back", payload);
      const { data } = await PbxHttpClient.post("/clients/client_external", payload);
      // console.log("REGISTRO", data);
      commit("PUSH_EXTERNAL_CLIENT", data.external);
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async SHOW_CLIENTS({ commit }) {
    try {
      const response = await PbxHttpClient.get("/clients/show");
      commit("SET_ALL_CLIENTS", response.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async SHOW_EXTERNAL_CLIENTS({ commit }, payload) {
    try {
      const { data } = await PbxHttpClient.get(`/clients/client_external?page=${payload.page}`);
      commit("SET_ALL_EXTERNAL_CLIENTS", data.data);
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_ACTIVE_CLIENTS({ commit }) {
    try {
      const response = await PbxHttpClient.get("/clients/activated");
      commit("SET_ALL_CLIENTS", response.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async EDIT_CLIENTS({ commit }, payload) {
    try {
      const response = await PbxHttpClient.put(`/clients/update/${payload.id}`, payload.value);
      commit("UPDATE_USER", response.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async EDIT_EXTERNAL_CLIENTS({ commit }, payload) {
    try {
      const response = await PbxHttpClient.put(`/clients/client_external/${payload.id}`, payload.value);
      commit("UPDATE_EXTERNAL_USER", response.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async DELETE_CLIENTS({ commit }, payload) {
    try {
      const response = await PbxHttpClient.delete(`/clients/delete/${payload.id}`);
      commit("DELETE_USER", payload.id);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async DELETE_EXTERNAL_CLIENTS({ commit }, payload) {
    try {
      const response = await PbxHttpClient.delete(`/clients/client_external/${payload.id}`);
      commit("DELETE_EXTERNAL_USER", payload.id);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async CHANGE_STATUS({ commit }, payload) {
    try {
      const res = await PbxHttpClient.get(`clients/client_status/${payload.id}`);
      commit("UPDATE_USER", res.data);
      return;
    } catch (error) {
      return Promise.reject();
    }
  },
};

// Exportar Clientes
export const clients = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
